import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'digires-location-picker',
  templateUrl: './location-picker.component.html',
  styleUrls: ['./location-picker.component.scss']
})
export class LocationPickerComponent {

  result: {latitude: number, longitude: number};

  constructor(@Inject(MAT_DIALOG_DATA) public data: {latitude: number, longitude: number}) {}

}
